"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _lang = _interopRequireDefault(require("@/lang"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var tree = [];
var defaultProps = {
  children: "childs",
  label: "title"
};
var _default = {
  name: "organizationUserMenu:view",
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  computed: {
    rules: function rules() {
      return {
        menuName: [{
          required: true,
          message: _lang.default.t('SMS.name') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: _lang.default.t('SMS.type') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: "blur"
        }],
        desc: [],
        permission: []
      };
    }
  },
  data: function data() {
    return {
      listQuery: {
        menuName: ""
      },
      listLoading: true,
      viewData: {},
      defaultProps: defaultProps,
      showDialog: false,
      tableHeight: 1080,
      formData: {},
      formTitle: "",
      formButton: "",
      tree: null,
      multipleSelection: null
    };
  },
  created: function created() {
    this.tableHeight = window.innerHeight - 440;
    this.getList();
  },
  methods: {
    viewDate: function viewDate() {
      this.fillView(this.$refs.tree.getCurrentNode());
    },
    handleSelectionChange: function handleSelectionChange() {
      this.multipleSelection = this.$refs.tree.getCheckedNodes();
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true;

      _httpUtils.default.post("organizationUserMenu", "tree", null, this.listQuery).then(function (res) {
        _this.tree = res.data.menus;
        setTimeout(function () {
          _this.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleSubmit: function handleSubmit(form) {
      if (form === _lang.default.t("SMS.create")) {
        this.doCreateData();
      } else if (form === _lang.default.t("SMS.update")) {
        this.doUpdateData();
      }
    },
    closeDialog: function closeDialog() {
      var _this2 = this;

      this.showDialog = false;
      this.formData = {};
      this.$nextTick(function () {
        return _this2.$refs["dataForm"].clearValidate();
      });
    },
    initForm: function initForm(cmd) {
      if (cmd == "add") {
        this.formTitle = _lang.default.t("SMS.createNewUser");
        this.formButton = _lang.default.t("SMS.create");
      } else if (cmd == "edit") {
        this.formTitle = _lang.default.t("SMS.editUser");
        this.formButton = _lang.default.t("SMS.update");
      } else if (cmd == "view") {
        this.formTitle = _lang.default.t("SMS.viewUser");
      }

      this.formData = {
        menuIds: []
      };
      this.viewOnly = false;
    },
    fillForm: function fillForm(node) {
      this.formData = {
        parentId: node.parentId,
        menuName: node.title,
        type: node.data.type,
        config: node.data.config,
        icon: node.icon,
        perms: node.data.perms,
        orderNum: node.data.orderNum,
        menuId: node.id,
        url: node.data.url
      };
    },
    fillView: function fillView(node) {
      this.viewData = {
        parentId: node.parentId,
        menuName: node.title,
        type: node.data.type,
        config: node.data.config,
        icon: node.icon,
        perms: node.data.perms,
        orderNum: node.data.orderNum,
        menuId: node.id,
        url: node.data.url
      };
    },
    handleDialog: function handleDialog(cmd) {
      var _this3 = this;

      var checkedNodes = this.$refs.tree.getCheckedNodes();

      if (this.checkNumberOfSelection(checkedNodes, cmd)) {
        this.initForm(cmd);

        if (cmd == "add") {
          if (checkedNodes[0]) {
            this.formData.parentId = checkedNodes[0].id;
          } else {
            this.formData.parentId = null;
          }
        }

        if (cmd == "edit") {
          this.fillForm(checkedNodes[0]);
        }

        this.$nextTick(function () {
          _this3.showDialog = true;
        });
      }
    },
    checkNumberOfSelection: function checkNumberOfSelection(nodes, cmd) {
      var message, info;

      if (nodes === undefined ? true : nodes.length > 1) {
        message = _lang.default.t("message.Message39");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return false;
      }

      if (nodes.length === 0 && cmd === "edit") {
        message = _lang.default.t("message.Message39");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return false;
      }

      return true;
    },
    doCreateData: function doCreateData() {
      var _this4 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("organizationUserMenu", "add", null, _this4.formData).then(function (res) {
            if (res.code === 200) {
              _this4.$notify({
                title: _lang.default.t("message.message6"),
                message: res.data,
                type: "success",
                duration: 2000
              });

              _this4.showDialog = false;
              setTimeout(function () {
                _this4.closeDialog();

                _this4.getList();
              }, 1.5 * 1000);
            }
          }).catch(function (e) {
            _this4.$notify({
              title: _lang.default.t("SMS.alarm"),
              message: _lang.default.t("message.message40") + ',' + e.message,
              type: "warning",
              duration: 2000
            });
          });
        }
      });
    },
    doUpdateData: function doUpdateData() {
      var _this5 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("organizationUserMenu", "update", null, _this5.formData).then(function (res) {
            if (res.code === 200) {
              _this5.$notify({
                title: _lang.default.t("message.message41"),
                message: res.data,
                type: "success",
                duration: 2000
              });

              _this5.showDialog = false;
              setTimeout(function () {
                _this5.closeDialog();

                _this5.getList();
              }, 1.5 * 1000);
            }
          }).catch(function (e) {
            _this5.$notify({
              title: _lang.default.t("SMS.alarm"),
              message: _lang.default.t("message.message42") + ',' + e.message,
              type: "warning",
              duration: 2000
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(state) {
      var _this6 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "delete") {
        message = _lang.default.t("message.permissionMessage1");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this6.doDeleteData();
      }).catch(function () {
        _this6.$message({
          type: "info",
          message: _lang.default.t("message.message3")
        });
      });
    },
    doDeleteData: function doDeleteData() {
      var _this7 = this;

      var ids = "";

      for (var data in this.$refs.tree.getCheckedNodes()) {
        ids = ids === "" ? this.$refs.tree.getCheckedNodes()[data].id.toString() : ids.concat("," + this.$refs.tree.getCheckedNodes()[data].id.toString());
      }

      _httpUtils.default.post("organizationUserMenu", "delete", null, ids).then(function (res) {
        if (res.code === 200) {
          _this7.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("message.organizationManagementMessage4"),
            type: "success",
            duration: 2000
          });

          _this7.getList();
        } else {
          _this7.$message({
            showClose: true,
            message: _lang.default.t("message.message5"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this7.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    checkSelection: function checkSelection() {
      var checkedNodes = this.$refs.tree.getCheckedNodes();
      var message, info;

      if (checkedNodes === undefined ? true : checkedNodes.length === 0) {
        message = _lang.default.t("message.message16");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return true;
      }

      return false;
    }
  }
};
exports.default = _default;